import { TaxRole } from './tax-role.enum';

export class QuestionnaireSubmission {
    id = -1;
    role = TaxRole.Owner;
    blocking = true;
    date = new Date();
    message = '';

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.role = data.role ?? TaxRole.Owner;
        this.blocking = data.blocking ?? true;
        this.date = data.date !== null ? new Date(data.date) : new Date();
        this.message = data.message ?? '';
        return this;
    }

    serialize() {
        return {
            blocking: this.blocking,
        };
    }

    clone(): QuestionnaireSubmission {
        return new QuestionnaireSubmission().deserialize({
            id: this.id,
            role: this.role,
            blocking: this.blocking,
            date: this.date.toISOString(),
            message: this.message,
        });
    }
}
